import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CreateDisplayComponent } from '../create-display/create-display.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DisplayService } from 'app/services/display.service';
import { SweetalertService } from 'app/services/sweetalert.service';
import { take } from 'rxjs/operators';
import { SelectIndicatorsComponent } from 'app/shared/select-indicators/select-indicators.component';
import { InterfaceDisplay } from 'app/models/display.model';

@Component({
  selector: 'app-display-table',
  templateUrl: './display-table.component.html',
  styleUrls: ['./display-table.component.scss']
})
export class DisplayTableComponent implements OnInit, OnDestroy {

  displays: InterfaceDisplay[] = [];
  subscriptions: Subscription[] = [];
  showIndicators = false;
  selectedDisplay: InterfaceDisplay = {};

  constructor(
    public modal: NgbModal,
    protected displayService: DisplayService,
    public swal: SweetalertService
  ) { }

  ngOnInit(): void {
    this.getDisplays();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  getDisplays(): void {
    this.subscriptions.push(
      this.displayService.getDisplays().pipe(take(1)).subscribe((result: InterfaceDisplay[]) => {
        this.displays = result;
      }, (error: any) => {
        console.error(error);
      })
    );
  }

  addDisplay(): void {
    this.modal.open(CreateDisplayComponent, {
      centered: true,
      backdrop: "static",
      animation: true
    });
  }

  returnDateToShow(dayToShow: number): string {
    switch (dayToShow) {
      case 1:
        return "Monday";
      case 2:
        return "Tuesday";
      case 3:
        return "Wednesday";
      case 4:
        return "Thursday";
      case 5:
        return "Friday";
      case 6:
        return "Saturday";
      case 7:
        return "Sunday";
      default:
        return "No date to display"
    }
  }

  goBack(): void {
    this.showIndicators = false;
    this.selectedDisplay = {};
  }

  viewIndicators(display: any): void {
    this.showIndicators = true;
    this.selectedDisplay = display;
  }

  addIndicators(display: any): void {
    const modalRef = this.modal.open(SelectIndicatorsComponent, {
      centered: true,
      backdrop: "static",
      animation: true
    });
    modalRef.componentInstance.indicatorsIds = display.indicators;
    modalRef.result.then((result: any) => {
      if (result && result.length > 0) {
        display.indicators = result;
        this.displayService.updateEmployee(display).then(() => {
          this.swal.showSuccess();
        }).catch((error: any) => {
          console.error(error);
          this.swal.showError();
        });
      }
    }).catch((error: any) => {
      console.error(error);
    });
  }

}
